import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef, EventEmitter, HostBinding,
  Input,
  OnInit, Output, QueryList,
  ViewChild, ViewChildren
} from '@angular/core';
import {LMListCardService, LMListEventService} from '@list/services';
import { SohoRatingComponent } from 'ids-enterprise-ng';
import { LMCardBaseDirective } from '@card/lm-card-base.directive';
import { LMComponentInfoService, LMUrlUtilService } from '@app/services';
import { LMNavigationService } from '@app/components';

@Component({
  selector: 'lm-sectioned-card',
  templateUrl: 'lm-sectioned-card.component.html',
  styleUrls: [ 'lm-sectioned-card.component.scss' ],
  providers: [ LMListCardService ],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class LMSectionedCardComponent extends LMCardBaseDirective implements OnInit, AfterViewInit {
  public templateData: Array<LMSectionedCardTemplate>;

  @ViewChild('ImageSection') imageSection: ElementRef;
  @ViewChild('TitleSection') titleSection: ElementRef;
  @ViewChildren(SohoRatingComponent) ratingComponents: QueryList<SohoRatingComponent>;

  @Input() dataView: LMDataView;
  @Input() sectionedCard: LMSectionedCard;
  @Input() isMoreLink: boolean;

  @HostBinding('style.width.px') cardWidth: number;
  @HostBinding('style.max-width.px') cardMaxWidth: number;
  @HostBinding('style.min-width.px') cardMinWidth: number;

  constructor(
    protected lmComponentInfoService: LMComponentInfoService,
    protected lmNavigationService: LMNavigationService,
    protected lmUrlUtilService: LMUrlUtilService,
    private lmListCardService: LMListCardService,
    private lmListEventService: LMListEventService
  ) {
    super(lmComponentInfoService, lmNavigationService, lmUrlUtilService);
  }

  ngOnInit() {
    this.setCardWidth();
    this.load();
  }

  ngAfterViewInit() {
    if (this?.ratingComponents?.length > 0) {
      this.ratingComponents.forEach((ratingComponent: SohoRatingComponent) => {
        ratingComponent.readonly();
      });
    }
  }

  public load() {
    this.templateData = this.lmListCardService.getSectionedCardData(this.sectionedCard, this.dataView);
  }

  public getComponentInfo(): LMComponentInfo {
    throw new Error('Method not implemented.');
  }

  public onUILinkEvent(navigationParams: LMCardNavigationParams) {
    const uiLinkEvent: LMUILinkEvent = {
      dataView: navigationParams.dataView,
      navigationParams,
      columnDef: null,
      event: null
    };

    this.lmListEventService.uiLinkEvent(uiLinkEvent);
  }

  private setCardWidth() {
    const width = 320;
    this.lmListCardService.cardWidth = width;
    this.cardWidth = width;
    this.cardMaxWidth = width;
    this.cardMinWidth = width;
  }
}
